import LocalTime from '@vivotek/lib-utility/local_time';

export default LocalTime;
